import React, { useState, useEffect } from 'react';
import { getKey, getOptionName } from '../../../item/ItemTools';
import { DatePickerInput } from 'rc-datepicker';
import { PointMarker } from '../../../item/MyStat/PointMarker';
import { EditButton } from './BaseButton';

/**
 * 顯示文字
 * @param {*} param0 
 */
export function SingleText({ title, val, size = 3, color='success' }) {
  const [colSize] = useState("col-md-" + size)


  return (
    <div className={colSize}>
    {
      title === undefined ? <></> :
        title === "" ? <p>&nbsp;</p> :
          <p>{title}</p>
    }
      <p className={"text-"+color}>{val}</p>
    </div>
  )
}

/**
 * 顯示多行文字
 * @param {*} param0 
 */
export function SingleMultilineText({ title, val, size = 3 }) {
  const [colSize] = useState("col-md-" + size)

  if (title !== undefined) {
    title = <p>{title}</p>
  } else {
    title = <></>
  }

  return (
    <div className={colSize}>
      {title}
      <p className="text-success" style={{ whiteSpace: "pre-line" }}>{val}</p>
    </div>
  )
}

/**
 * 輸入框
 * @param {string} title 標題, 傳空白仍會佔位, 若要不佔位則要傳 undefined
 * @param {string} val 輸入框顯示的值
 * @param {string} id 有此值時會在改變時回傳
 * @param {function} action 輸入改變時呼叫的 function
 * @param {int} size 佔空間的大小
 * @param {string} type 僅支援 text 及 number
 * @param {boolean} disabled 是否禁止輸入
 * @param {boolean} isRight 是否靠右
 */
export function SingleInput({ title, val = "", id, action, action_blur, placeholder = "", size = 3, type = "text", step = 1, disabled = false, isRight = false }) {
  const [mVal, setVal] = useState("")
  const [mPlaceholder, setPlaceholder] = useState("")
  const [colSize] = useState("col-md-" + size + " " + (isRight ? "pull-right" : ""))
  const [isChange, setChange] = useState(false)

  useEffect(() => {
    if (val !== undefined && val !== mVal) {
      setVal(val)
    }
  }, [val])

  useEffect(() => {
    if (placeholder !== undefined && placeholder !== mPlaceholder) {
      setPlaceholder(placeholder)
    }
  }, [placeholder])


  function setAction(v) {
    if (action !== undefined) {
      if (type === "number") {
        if (step < 1) {
          v = parseFloat(v)
        } else {
          v = parseInt(v)
        }
      }
      if (id !== undefined) {
        action(id, v)
      } else {
        action(v)
      }
    }
    // setVal(v)
  }
  function onChange(v) {
    // console.log(v)
    setVal(v)
    setChange(true)
    // console.log('改變')
  }
  function onBlur(v) {
    // console.log(v)
    if (isChange) {
      setAction(v)
      setChange(false)
      if(action_blur !== undefined)
        action_blur(v)
    }
    // console.log('離開')
  }

  return (
    <div className={colSize}>
      {
        title === undefined ? <></> :
          title === "" ? <p>&nbsp;</p> :
            <p>{title}</p>
      }
      <input type={type}
        step={step}
        className="form-control required" style={{ textAlign: isRight ? 'right' : 'left' }}
        value={mVal}
        // onChange={e => setAction(e.target.value)}
        onChange={e => onChange(e.target.value)}
        onBlur={e => onBlur(e.target.value)}
        placeholder={mPlaceholder}
        disabled={disabled}
      />
    </div>
  )
}
export function SingleTextArea({ title, val = "", action, size = 12, rows = 10, disabled = false }) {
  const [mVal, setVal] = useState("")
  const [colSize] = useState("col-md-" + size)

  useEffect(() => {
    if (val !== undefined && val !== mVal) {
      setVal(val)
    }
  }, [val])


  function setAction(v) {
    if (action !== undefined) {
      action(v)
    }
    setVal(v)
  }

  return (

    <div className={colSize}>
      {title === undefined ? <></> :
        <p>{title}&nbsp;</p>
      }
      <textarea className="form-control"
        rows={rows}
        value={mVal}
        onChange={e => setAction(e.target.value)}
      >
        {mVal}
      </textarea>
    </div>
  )
}

/**
 * 單選
 * 
  const isDisableItems = [
    { "val": 0, "name": "是" },
    { "val": 1, "name": "否" },
  ]
  <SingleRedio title={"啟用狀態"}
    arr={isDisableItems}
    val={isDisable} action={setisDisable} />
 */

export const isDisableItems = [
  { "val": 0, "name": "是" },
  { "val": 1, "name": "否" },
]

export function SingleRedio({ title, arr = [], val, action, size = 3 }) {
  const [mVal, setVal] = useState(0)
  const [colSize] = useState("col-md-" + size)

  useEffect(() => {
    if (val !== undefined && val !== mVal) {
      setVal(val)
    }
  }, [val])

  var checkClass = "iradio_square-green checked"
  var uncheckClass = "iradio_square-green"

  function setRedio(v) {
    setVal(v)
    console.log(v)
    if (action !== undefined)
      action(v)
  }

  return (
    <>
      <div className={colSize}>
        <p>{title}</p>
        {
          arr.map((item) => (
            <span key={item.val} >
              <div className={mVal === item.val ? checkClass : uncheckClass}
                style={{ position: "relative" }}
                onClick={e => setRedio(item.val)}
              />
              <label> {item.name}</label>&nbsp;&nbsp;&nbsp;
            </span>
          ))
        }
      </div>
    </>
  )
}

/**
 * 複選
 * @param {*} param0 
 */
export function SingleCheck({ title, arr = [], val = [], action }) {
  const [mArr, setArr] = useState([])
  const [mVal, setVal] = useState([])
  const [statusArray, setStatusArray] = useState({})

  useEffect(() => {
    if (arr !== undefined && arr !== mArr) {
      setStyle(mVal)
      setArr(arr)
    }
  }, [arr])

  useEffect(() => {
    if (val !== undefined && val !== mVal) {
      setVal(val)
    }
  }, [val])

  function setStyle(vals) {
    var ar = {}
    arr.map((item) => {
      var f = vals.find(x => x === item)
      if (f === undefined)
        ar[item] = uncheckClass
      else
        ar[item] = checkClass
    })
    setStatusArray(ar)
  }

  var checkClass = "icheckbox_square-green checked"
  var uncheckClass = "icheckbox_square-green"

  function setCheck(v) {
    var f = mVal.find(x => x === v)
    if (f === undefined) {
      mVal.push(v)
    } else {
      var index = mVal.indexOf(v)
      mVal.splice(index, 1);
    }
    console.log(mVal)
    setVal(mVal)
    setStyle(mVal)
    if (action !== undefined)
      action(mVal)
  }

  if (statusArray === undefined)
    return (<></>)
  else {
    return (
      <>
        <div className="col-md-3">
          <p>{title}</p>
          {
            arr.map((item) => (
              <span key={item} >
                {/*console.log(statusArray[item])*/}
                <div className={statusArray[item]}
                  style={{ position: "relative" }}
                  onClick={e => setCheck(item)}
                />
                <label> {item}</label>&nbsp;&nbsp;&nbsp;
              </span>
            ))
          }
        </div>
      </>
    )
  }
}

export const SELECT_VAL_TYPE_STRING = "string"
export const SELECT_VAL_TYPE_INT = "int"

/**
 * 下拉選單
 * @param {string} title 標題
 * @param {Array} attr 列表{[
                            { "val": "1", "name": "薪資轉帳-本人" },
                            { "val": "2", "name": "薪資轉帳-他人" },
                            { "val": "3", "name": "領取現金" }]}
 * @param {string} val 指定值
 * @param {function} action 返回值
 * @param {int}} size 大小
 * @param {string}} v attr 中的數值欄位
 * @param {string}} n attr 中的顯示欄位
 */
export function SingleSelect({ title, attr = [], id, val, defaultVal, action, valType = SELECT_VAL_TYPE_STRING, size = 3, v = "val", n = "name", optionN, hasBlank = false, blankVal = "", blankOption = '請選擇', debug = false, setWidth = false }) {
  const [mVal, setVal] = useState(defaultVal)
  const [mAttr, setAttr] = useState([])
  const [colSize] = useState("col-md-" + size)
  const [optionName, setOptionName] = useState([{ ov: "k", on: n }])
  const [width] = useState(!setWidth ? {} : { width: size * 75 })

  useEffect(() => {
    if (optionN !== undefined && optionN !== optionName) {
      //console.log(optionN)
      setOptionName(optionN)
    }
  }, [optionN])

  useEffect(() => {
    if (val !== undefined && val !== mVal) {
      
    // if(id==='game_activation'){
    //   console.log(val)
    // }
      setVal(val)
    }
  }, [val])

  // useEffect(()=>{
  //   if(id==='game_activation'){
  //     console.log(mVal)
  //   }
  // },[mVal])

  useEffect(() => {
    if (attr !== undefined && attr !== mAttr) {
      setAttr(attr)
      //console.log(attr)
    }
  }, [attr])


  function setSelect(v) {
    if (action !== undefined) {
      var val = v
      if (valType === SELECT_VAL_TYPE_INT) {
       val = parseInt(v)
      }
      if(id !== undefined){
        action(id, val)
      }else{
        action(val)
      }
    }
    setVal(val)
  }

  var blank = <></>
  if (hasBlank) {
    blank = <option value={blankVal}>{blankOption}</option>
  }

  if (debug) {
  }

  try {
    return (
      <>
        <div className={colSize}>
          {title === undefined ? <></> :
            <p>{title}</p>
          }
          <select className="select2_demo_1 form-control" style={width} value={mVal} onChange={e => setSelect(e.target.value)} >
            {blank}
            {
              mAttr.map((item) => (
                <option key={getKey({})} value={item[v]}>{getOptionName(item, optionName)}</option>
              ))}
          </select>
        </div>
      </>
    )
  } catch (error) {
    return (
      <>
        <div className={colSize}>
          <p>{title}</p>
          <select className="select2_demo_1 form-control" value={mVal}  >
            {blank}
          </select>
        </div>
      </>
    )
  }

}

/**
 * 檢查是否取消的核選方塊
 * @param {*} param0 
 */
export function CheckDisable({ title = "是否停用", obj, isDisable, sd }) {
  const [mObj, setObj] = useState(-1)
  const [mIsDisable, setisDisable] = useState(isDisable)

  useEffect(() => {
    if (obj !== mObj) {
      setObj(obj)
      setisDisable(isDisable)
    }
  }, [obj])

  function setDisable(val) {
    setisDisable(val)
    if (sd !== undefined)
      sd(val)
  }

  return (

    <div className="row">
      <div className="col-sm-6">
        <div className="row">
          <div className="col-sm-12">

            <div className="custom-control custom-switch">
              <input type="checkbox" checked={mIsDisable} onChange={e => setDisable(e.target.checked ? 1 : 0)} />
              <label className="custom-control-label" htmlFor="customSwitches">是否停用</label>
            </div>
          </div>
        </div>
      </div>
      <div className="col-sm-6">
        <div className="row">
          <div className="col-sm-12">
          </div>
        </div>
      </div>
    </div>
  )
}

/**
 * 是否啟用
 * @param {*} param0 
 */
export function CheckIsEnable({ obj, isDisable = false, setDisable }) {
  const [mObj, setObj] = useState(obj)
  const [mIsDisable, setisDisable] = useState(isDisable)

  var checkClass = "iradio_square-green checked"
  var uncheckClass = "iradio_square-green"

  useEffect(() => {
    if (obj !== undefined && obj !== mObj) {
      setObj(obj)
    }
  }, [obj])

  useEffect(() => {
    if (isDisable !== undefined && isDisable !== mIsDisable) {
      setisDisable(isDisable)
    }
  }, [isDisable])

  function setChoose() {
    var isD = !mIsDisable
    if (setDisable !== undefined) {
      setDisable(isD ? 1 : 0)
    }
    setisDisable(isD)
  }

  return (
    <>
      <div className={mIsDisable ? uncheckClass : checkClass} onClick={e => setChoose()} style={{ position: "relative" }}>
      </div>&nbsp;
      <label>是</label>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <div className={!mIsDisable ? uncheckClass : checkClass} onClick={e => setChoose()} style={{ position: "relative" }}>
      </div>&nbsp;
      <label>否</label>
    </>
  )
}

/**
 * 單純只有勾選方塊
 * @param {*} param0 
 */
export function SingleCheckBox({ isCheck = false, setCheck }) {
  const [mIsCheck, setIsCheck] = useState(isCheck)

  var checkClass = "icheckbox_square-green checked"
  var uncheckClass = "icheckbox_square-green"

  useEffect(() => {
    if (isCheck !== undefined && isCheck !== mIsCheck) {
      setIsCheck(isCheck)
    }
  }, [isCheck])

  function setChoose() {
    var isD = !mIsCheck
    if (setCheck !== undefined) {
      setCheck(isD ? 1 : 0)
    }
    setIsCheck(isD)
  }

  return (
    <>
      <div className={mIsCheck ? checkClass : uncheckClass} onClick={e => setChoose()} style={{ position: "relative" }}>
      </div>
    </>
  )
}

export function SingleDatePickerInput({ title, value, action, feedback, errString = "", displayFormat = 'YYYY/MM/DD', returnFormat = 'YYYY-MM-DD', size = 3 }) {

  const [colSize] = useState("col-md-" + size)
  console.log(title)
  console.log(value)

  const onChange = (jsDate, dateString) => {
    // console.log(jsDate)
    // console.log(dateString)
    if (dateString === "Invalid date") {
      if (feedback) {
        feedback(true, errString)
      }
    } else {
      if (feedback)
        feedback(false, errString)
      if (action)
        action(dateString)
    }
  }
  const onClear = () => {
    if (feedback)
      feedback(false, errString)
    if (action)
      action("")
  }
  const onShow = () => {
    // console.log("onShow")
  }
  const onHide = () => {
    // console.log("onHide")
  }
  return (
    <div className={colSize}>
      <p>{title}</p>
      <DatePickerInput
        displayFormat={displayFormat}
        returnFormat={returnFormat}
        onChange={onChange}
        onClear={onClear}
        onShow={onShow}
        onHide={onHide}
        value={value}
        showOnInputClick={true}
        className='my-react-component'
      />
    </div>)
}

/** 公司負擔 */
export function getDangerText(text) {
  return <span className="text-danger">{text}</span>
}

/** 廠商負擔 */
export function getSuccessText(text) {
  return <span className="text-success">{text}</span>
}

/** 個人負擔 */
export function getInfoText(text) {
  return <span className="text-info">{text}</span>
}

export const SinglePointMarker = ({ title, background, initPos, setPos, size, field }) => {
  const colSize = `col-md-${size}`
  const [edit, setEdit] = useState(false)
  return (
    <div className={colSize}>
      {title === undefined ? <></> :
        <p>{title}&nbsp;</p>
      }
      { edit?
        <PointMarker background={background} initX={initPos[0]} initY={initPos[1]} handleOnChange={setPos} field={field} />
        :<span>{`(${initPos[0]}, ${initPos[1]})`} <span>　</span> <EditButton name={"修改"} action={()=>{setEdit(true)}} /> </span>
      }
    </div>
  )
}